import { EnvVariablesModule } from "@pharaday/env";
import { Container, ContainerModule } from "inversify";
import "reflect-metadata";

import { FeatureFlagIdentificationService } from "./application";
import { FeatureFlagService } from "./application/feature-flag.service";
import { InMemFeatureFlagIdentificationService } from "./infrastructure/feature-flag-identification-service/in-mem-feature-flag-identification.service";
import { PostHogFeatureFlagIdentificationService } from "./infrastructure/feature-flag-identification-service/posthog-feature-flag-identification.service";
import { InMemFeatureFlagService } from "./infrastructure/feature-flag-service/in-mem-feature-flag.service";
import { PosthogFeatureFlagService } from "./infrastructure/feature-flag-service/posthog-feature-flag.service";

export const FeatureFlagModule = new ContainerModule(({ bind }) => {
  bind(FeatureFlagService).toDynamicValue(() => {
    if (process.env.NEXT_PUBLIC_USE_FAKE_IMPLEMENTATIONS === "true") {
      return new InMemFeatureFlagService();
    }
    return new PosthogFeatureFlagService();
  });
  bind(FeatureFlagIdentificationService).toDynamicValue(() => {
    if (process.env.NEXT_PUBLIC_USE_FAKE_IMPLEMENTATIONS === "true") {
      return new InMemFeatureFlagIdentificationService();
    }
    return new PostHogFeatureFlagIdentificationService();
  });
});

export const FeatureFlagContainer = new Container({ defaultScope: "Singleton" });

FeatureFlagContainer.load(EnvVariablesModule, FeatureFlagModule);
